import {
  landFilterDefaults,
  landFilterFields,
} from '@/common/constants/filter';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { FilterSchema } from '../schema/filter.schema';

export default function useFilter() {
  const form = useForm({
    resolver: yupResolver(FilterSchema),
    defaultValues: {},
  });

  const [, setSearchParams] = useSearchParams();

  const { control, handleSubmit, reset } = form;

  const removeEmptyValues = (obj: Record<string, any>): Record<string, any> => {
    return Object.fromEntries(
      Object.entries(obj)?.filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
  };

  const clearFilter = () => {
    reset(landFilterDefaults);
    setSearchParams((prev) => {
      landFilterFields.forEach((field) => prev.delete(field));
      return prev;
    });
  };

  const onSubmit = (values: any) => {
    const params = removeEmptyValues(values);
    setSearchParams((prev) => {
      landFilterFields.forEach((field) => {
        if (params[field]) prev.set(field, params[field]);
        else prev.delete(field);
      });
      return prev;
    });
  };

  return {
    form,
    control,
    clearFilter,
    handleForm: handleSubmit(onSubmit),
  };
}
